module.exports = __webpack_public_path__ + "media/images/my/bnr-mypage-inquiry-lg-88c9cd28053ef640eb16514dd540ae18.svg";